module.exports = __webpack_public_path__ + "static/media/footer-icon-3.31cf4a37.svg";